module.exports = __webpack_public_path__ + "static/media/welcome.11544cb2.png";